module.exports = __webpack_public_path__ + "img/nevs_level_C.4cc7f932.png";